import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { checkAll, IPermissionCheckResult } from '../../../../../modules/permissions/permissionsHelpers';
import { ICurrentWorkspaceStore } from '../../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Plan } from '../../../user/user.store';
import { WorkspaceRole } from '../../../workspaces/workspaces.store';

interface IClarificationsPermissions {
  canSeeClarifications(): IPermissionCheckResult;
  canClarify(): IPermissionCheckResult;
  canSeePersonalData(): IPermissionCheckResult;
}

export const useClarificationsPermissions = (): IClarificationsPermissions => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const currentWorkspace = currentWorkspaceStore.currentWorkspace;
  const { t } = useTranslator();

  const canClarify = (): IPermissionCheckResult => {
    return checkAll([Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
  };

  const canSeePersonalData = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free, Plan.Inactive],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  const canSeeClarifications = (): IPermissionCheckResult => {
    return checkAll([Plan.Admin, Plan.Training, Plan.Annotation, Plan.Free, Plan.Inactive], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
  };

  return {
    canClarify,
    canSeePersonalData,
    canSeeClarifications,
  };
};
